import React from "react";

const RemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        id="RemoveIcon"
        d="M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM17,13H7V11H17Z"
        transform="translate(-3 -3)"
        fill="rgba(178,0,0,0.78)"
      />
    </svg>
  );
};

export default RemoveIcon;
